import React from "react";
import "../css/licenciados.css";

// Imágenes
import Lic01 from "../img/Licenciatura 8° 2024.jpeg";
import Lic02 from "../img/Graduación Kinder 2024.jpg";
import Lic03 from "../img/Licenciatura 8vo básico 2025.JPG";
import Lic04 from "../img/Kinder 2025.jpg";

const licenciadosData = [

    {
        id: 4,
        title: "Graduación Kinder",
        generation: "Generación 2025",
        imageUrl: Lic04,
    },

    {
        id: 3,
        title: "Licenciatura 8° Básico",
        generation: "Generación 2025",
        imageUrl: Lic03,
    },

    {
        id: 2,
        title: "Graduación Kinder",
        generation: "Generación 2024",
        imageUrl: Lic02,
    },

    {
        id: 1,
        title: "Licenciatura 8° Básico",
        generation: "Generación 2024",
        imageUrl: Lic01,
    }

];

const LicenciadosComponent = () => {

    const abrirImagen = (imagen) => {
        window.open(imagen, "_blank");
    };

    return (

        <section
            id="licenciados-component"
            className="esc-lic-container"
        >

            <h2 className="esc-lic-title">
                Licenciados & Graduados
            </h2>

            <p className="esc-lic-subtitle">
                Un espacio dedicado a preservar la historia de cada generación
                que ha formado parte de la Escuela Nueva Zelandia. Aquí permanecen
                los recuerdos de las ceremonias de Graduación de Kinder y
                Licenciatura de 8° Básico para que estudiantes, familias y
                exalumnos puedan revivir estos importantes momentos a través del
                tiempo.
            </p>

            <div className="esc-lic-grid">

                {licenciadosData.map((item) => (

                    <div
                        key={item.id}
                        className="esc-lic-card"
                    >

                        <div className="esc-lic-header">

                            {item.title}

                        </div>

                        <div className="esc-lic-body">

                            <div
                                className="esc-lic-image-wrapper"
                                onClick={() => abrirImagen(item.imageUrl)}
                            >

                                <img
                                    src={item.imageUrl}
                                    alt={item.title}
                                    className="esc-lic-image"
                                />

                                <div className="esc-lic-overlay">

                                    <span>
                                        📸 Ampliar recuerdo
                                    </span>

                                </div>

                            </div>

                        </div>

                        <div className="esc-lic-footer">

                            <div className="esc-lic-year">

                                {item.generation}

                            </div>

                        </div>

                    </div>

                ))}

            </div>

        </section>

    );

};

export default LicenciadosComponent;